module.exports = __webpack_public_path__ + "static/img/logo1.75dcaa10.png";